<script lang="ts">
  export let message: string | undefined = undefined;
  export let slightlyOver: boolean = true;
</script>

{#if message}
  <div aria-live="assertive">
    <div class="select-none pointer-events-none fake-parsley" class:slightly-over={slightlyOver} aria-hidden="false">
      <span class="parsley-required">
        {message}
      </span>
    </div>
  </div>
{/if}

<style>
  .fake-parsley {
    font-size: 0.75rem;
    position: absolute;
    line-height: 1;
    background-color: #fbe3e7;
    color: #212121;
    padding: 2px 8px;
    border: 1px solid #212121;
    border-radius: 4px;
    top: 100%;
    z-index: 12;
    left: 12px;
  }

  .fake-parsley.slightly-over {
    top: calc(100% - 8px);
  }
</style>
